<div app-sidenav class="flex flex-col overflow-hidden">
  @if (items$ | async; as items) {
    <div class="flex flex-col gap-2 py-7">
      <span class="text-lg font-semibold" translate> eclass.agenda.filtros.filtrar-agenda </span>
      <div class="flex flex-col p-1 shadow-inner-horizontal! gap-1 rounded-2xl">
        @for (item of items.folders; track $index; let first = $first; let last = $last) {
          <button
            class="flex justify-between shadow shadow/20 bg-base-gray-light-300 last:mb-3 not-first:mx-3 items-center p-3 current:text-white rounded-xl cursor-pointer transition group text-theme-900 {{
              item.style
            }}"
            [ngClass]="{ current: item.isCurrent(workerId()) }"
            (click)="onFilter(item.worker)"
          >
            <div class="flex items-center gap-2">
              <svg-icon class="h-6 w-6 flex justify-center items-center" [src]="item.icon | icon"></svg-icon>
              <span class="text-md font-medium group-current:font-semibold"> {{ item.title | translate }}</span>
            </div>
          </button>
        }
      </div>
    </div>

    @if ((items.folders | noEmpty) && (items.modules | noEmpty)) {
      <hr />
    }
    @if (items.modules | noEmpty) {
      <div class="flex flex-col gap-2 py-7">
        @for (item of items.modules; track $index) {
          <button
            class="flex justify-between items-center bg-base-gray-light-300 current:text-white p-3 rounded-xl cursor-pointer transition group text-theme-900 {{
              item.style
            }}"
            [ngClass]="{ current: item.isCurrent(workerId()) }"
            (click)="onFilter(item.worker)"
          >
            <div class="flex items-center gap-2">
              <svg-icon class="h-6 w-6 flex justify-center items-center" [src]="item.icon | icon"></svg-icon>
              <span class="text-md font-medium group-current:font-semibold"> {{ item.title | translate }}</span>
            </div>
          </button>
        }
      </div>
    }
  }

  <app-calendar-post></app-calendar-post>
</div>
